import React from "react";
import { Link } from "react-router-dom";

export default function UserDashBoradStatusCom(props) {
  return (
    <Link
      to={props.to ? props.to : null}
      className={`${props.to ? "cursor-pointer" : "cursor-default"}`}
    >
      <div className="relative xs:px-2 xs:py-3 sm:px-3 sm:py-3 lg:py-4 lg:px-4 3xl:px-5 3xl:py-4 xs:!rounded-[4px] sm:rounded-md lg:rounded-lg flex justify-start xs:gap-2.5 sm:gap-3 lg:gap-4 items-center bg-raisinBlackSecondary">
        <div className="xs:w-7 xs:h-7 sm:w-8 sm:h-8 lg:w-10 lg:h-10 3xl:w-14 3xl:h-14 flex justify-center items-center">
          <img
            src={props.icon}
            className={`${props.iconLayout}`}
            alt="status Icons"
          />
        </div>
        <h2 className="text-secondary xs:text-xs sm:text-sm lg:text-base 3xl:text-lg font-onestSemiBold">
          {props.title}
        </h2>
        <div
          className={`absolute ${props.postion} flex shadow-[0px_6px_6px_rgba(0,0,0,0.2)] justify-center items-center`}
          style={{ backgroundColor: props.layout }}
        >
          <p className={`text-primary ${props.textsize}`}>
            {props.notification}
          </p>
        </div>
      </div>
    </Link>
  );
}
